import type { PPProviderBehavior } from '../types';

export const defaultPPBehavior: PPProviderBehavior = {
	label: 'Default',
	cardDeviceDisplayName: 'EMV device',
	requiresPrepareTransaction: false,
	requiresPayorInformation: true,
	cardPrepareAutoStart: false,
	getReceiptInvoiceNumber(item, cartId, obscure) {
		if (cartId) return cartId;
		return obscure ? (item.obscuredItemNumber ?? item.itemNumber) : item.itemNumber;
	},
};
